import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgEmergency(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("path", {
      d: "M15 56V35c0-9.389 7.611-17 17-17v0c9.389 0 17 7.611 17 17v21M8 56h48",
      stroke: "#7373FF",
      strokeWidth: 3,
      strokeLinecap: "round"
    }, void 0), _jsx("path", {
      d: "M25 38h14M32 31v14M32 6v6M20 8l2.052 5.638M41.95 13.638L44 8M10 14l3.857 4.596M50.14 19l3.857-4.596",
      stroke: "#FF6652",
      strokeWidth: 3,
      strokeLinecap: "round"
    }, void 0)]
  }), void 0);
}

export default SvgEmergency;